module.exports = __webpack_public_path__ + "img/bg2.0f4864b7.png";